import type z from '@/lib/zod';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

export const foreignVendorsSearchSchema = commonSearchSchema.extend({
  /** Tab della tabella (Tutti / Attivi / Disattivi), come la webapp. */
  subTab: optionalSearchString(),
});

export type ForeignVendorsSearch = z.output<typeof foreignVendorsSearchSchema>;
